import BackendSettings from '../modules/siteSettings/components/backendSettings/components'
import ContactSetting from '../modules/siteSettings/components/contactSettings/ContactSetting'
import KeySettings from '../modules/siteSettings/components/keySetting/components'
import ModuleManager from '../modules/siteSettings/components/moduleManager/components/ModuleManager'
import Settings from '../modules/siteSettings/components/settings/components'
import SmtpSettings from '../modules/siteSettings/components/smtpSetting/components'
import Departments from '../modules/userMgmt/components/departments/components'
import Branches from '../modules/userMgmt/components/branch/components'
import RoleManagementIndex from '../modules/userMgmt/components/roles/components/RoleMgmt'
import UserRoleManagementIndex from '../modules/userMgmt/components/userRoles/UserRole'
import UserManagementIndex from '../modules/userMgmt/components/users/components/users'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'

import ContentManager from 'src/app/modules/cms/components/content/components/index'
import MenuManager from '../modules/cms/components/menu/components'

import Banner from '../modules/cms/components/banner/components'

import RoadBlockPopup from '../modules/cms/components/roadblockPopup/components'
import TextPopup from '../modules/cms/components/textPopup/components'

import FaqCategory from '../modules/cms/components/faqCategory/components'
import FaqManager from '../modules/cms/components/faqManager/components'

import EmailTemplate from '../modules/cms/components/emailTemplate/components'
import FormDownloadComponent from '../modules/formsAndDownload/components/formsDownload/component'

import HomepageSetting from '../modules/siteSettings/components/homepageSettings/components'

import React, {lazy} from 'react'
import {Error404} from '../modules/errors/components/Error404'

export interface RouteModel {
  path?: any
  component?: React.ComponentType<any>
  exact?: boolean
}

export const RouteList = [
  {
    path: '*',
    component: Error404,
  },
  {
    path: '/dashboard',
    component: DashboardWrapper,
    exact: true,
  },
  {
    path: '/cms/content',
    component: ContentManager,
    exact: true,
  },

  {
    path: '/cms/menu-manager',
    component: MenuManager,
    exact: true,
  },
  {
    path: '/cms/banner',
    component: Banner,
    exact: true,
  },

  {
    path: '/popup/text-popup',
    component: TextPopup,
    exact: true,
  },

  {
    path: '/popup/road-block-popup',
    component: RoadBlockPopup,
    exact: true,
  },
  {
    path: '/cms/manage-faqs',
    component: FaqCategory,
    exact: true,
  },
  {
    path: '/cms/update-faqs/:id',
    component: FaqManager,
    exact: true,
  },
  {
    path: '/cms/email-template',
    component: EmailTemplate,
    exact: true,
  },

  {
    path: '/usermanagement/users',
    component: UserManagementIndex,
    exact: true,
  },
  {
    path: '/usermanagement/user-role',
    component: UserRoleManagementIndex,
    exact: true,
  },
  {
    path: '/usermanagement/role',
    component: RoleManagementIndex,
    exact: true,
  },
  {
    path: '/usermanagement/departments',
    component: Departments,
    exact: true,
  },
  {
    path: '/usermanagement/branch',
    component: Branches,
    exact: true,
  },
  {
    path: '/sitesetting/module',
    component: ModuleManager,
    exact: true,
  },
  {
    path: '/sitesetting/contact-setting',
    component: ContactSetting,
    exact: true,
  },
  {
    path: '/sitesetting/homepage-setting',
    component: HomepageSetting,
    exact: true,
  },
  {
    path: '/sitesetting/backend-setting',
    component: BackendSettings,
    exact: true,
  },
  {
    path: '/sitesetting/setting',
    component: Settings,
    exact: true,
  },
  {
    path: '/sitesetting/smtp-setting',
    component: SmtpSettings,
    exact: true,
  },
  {
    path: '/sitesetting/key-setting',
    component: KeySettings,
    exact: true,
  },

  // BPM Form
  {
    path: '/form-generator',
    component: lazy(async () => await import('../modules/laravelForm/generator/index')),
    exact: true,
  },
  {
    path: '/form-manager',
    component: lazy(async () => await import('../modules/laravelForm/manager/index')),
    exact: true,
  },
  {
    path: '/form-manager/custom-json',
    component: lazy(async () => await import('../modules/laravelForm/FormManagerCustomJson/index')),
    exact: true,
  },

  // New CIF New Account
  {
    path: '/new-cif-new-account',
    component: lazy(async () => await import('../modules/newCifNewAccount')),
    exact: true,
  },
  {
    path: '/new-cif-new-account/rejected-account-lists',
    component: lazy(
      async () => await import('../modules/newCifNewAccount/rejectedList/accountRejectedList')
    ),
    exact: true,
  },
  {
    path: '/new-cif-new-account/account-opening-requests',
    component: lazy(
      async () => await import('../modules/newCifNewAccount/branchMaker/accountOpeningRequestPage')
    ),
    exact: true,
  },
  // {
  //   path: '/new-cif-new-account/create-new-account/normal-individual-preliminary-form',
  //   component: lazy(
  //     async () =>
  //       await import('../modules/newCifNewAccount/branchMaker/components/Individual/index')
  //   ),
  //   staticName: 'New CIF New Accounts',
  //   exact: true,
  // },
  // {
  //   path: '/new-cif-new-account/create-new-account/normal-individual-preliminary-form/:case_id',
  //   component: lazy(
  //     async () =>
  //       await import(
  //         '../modules/newCifNewAccount/branchMaker/components/Individual/normalIndividualForm'
  //       )
  //   ),
  //   staticName: 'New CIF New Accounts',
  //   exact: true,
  // },
  {
    path: '/new-cif-new-account/create-new-account',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/branchMaker/components/Individual/normalIndividualForm'
        )
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account/:case_id',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/branchMaker/components/Individual/normalIndividualForm'
        )
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account/review/:case_id',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/branchMaker/components/Individual/ReviewIndividual'
        )
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },

  // {
  //   path: '/new-cif-new-account/create-new-account/corporateScreenForm',
  //   component: lazy(
  //     async () => await import('../modules/screening/corporateScreening/corporateScreenPage')
  //   ),
  //   staticName: 'New CIF New Accounts',
  //   exact: true,
  // },
  // {
  //   path: '/new-cif-new-account/create-new-account/corporateScreenForm/:case_id',
  //   component: lazy(
  //     async () => await import('../modules/screening/corporateScreening/corporateScreenPage')
  //   ),
  //   staticName: 'New CIF New Accounts',
  //   exact: true,
  // },
  {
    path: '/new-cif-new-account/create-new-account/corporate/form',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/branchMaker/components/corporate/normalCorporateForm'
        )
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },

  {
    path: '/new-cif-new-account/create-new-account/corporate/form/:case_id',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/branchMaker/components/corporate/normalCorporateForm'
        )
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account/corporate/review-form/:case_id',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/branchMaker/components/corporate/ReviewFormCorporate'
        )
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },

  {
    path: '/new-cif-new-account/branch-checker-review',
    component: lazy(
      async () => await import('../modules/newCifNewAccount/branchChecker/corporate/index')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },

  {
    path: '/new-cif-new-account/branch-checker-review-individual',
    component: lazy(
      async () => await import('../modules/newCifNewAccount/branchChecker/Individual/index')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },

  // New CIF Only

  {
    path: '/new-cif-only',
    component: lazy(async () => await import('../modules/newCIFOnly/index')),
    exact: true,
  },
  {
    path: '/new-cif-only/cif-form-request-page',
    component: lazy(
      async () => await import('../modules/newCIFOnly/branchMaker/OpeningRequestPage')
    ),
    exact: true,
  },
  {
    path: '/new-cif-only/individual-cif-form',
    component: lazy(async () => await import('../modules/newCIFOnly/branchMaker/Individual/index')),
    exact: true,
  },
  {
    path: '/new-cif-only/individual-cif-form/:case_id',
    component: lazy(async () => await import('../modules/newCIFOnly/branchMaker/Individual/index')),
    exact: true,
  },
  {
    path: '/new-cif-only/review/:case_id',
    component: lazy(
      async () => await import('../modules/newCIFOnly/branchMaker/Individual/ReviewNewCIFOnly')
    ),
    staticName: 'New CIF Only',
    exact: true,
  },
  //corporate only
  {
    path: '/new-cif-only/corporate-cif-form',
    component: lazy(async () => await import('../modules/newCIFOnly/branchMaker/Corporate/index')),
    exact: true,
  },
  {
    path: '/new-cif-only/corporate-cif-form/:case_id',
    component: lazy(async () => await import('../modules/newCIFOnly/branchMaker/Corporate/index')),
    exact: true,
  },
  {
    path: '/new-cif-only/review/corporate/:case_id',
    component: lazy(
      async () => await import('../modules/newCIFOnly/branchMaker/Corporate/ReviewCorporateNewCIF')
    ),
    staticName: 'New CIF Only',
    exact: true,
  },
  // Existing CIF New Account
  {
    path: '/existing-cif-new-account',
    component: lazy(async () => await import('../modules/existingCIFNewAccount/index')),
    exact: true,
  },

  {
    path: '/existing-cif-new-account/rejected-account-lists',
    component: lazy(
      async () => await import('../modules/existingCIFNewAccount/rejectedList/accountRejectedList')
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },
  {
    path: '/existing-cif-new-account/opening-requests',
    component: lazy(
      async () =>
        await import(
          '../modules/existingCIFNewAccount/branchMakerChecker/accountOpeningRequestPage'
        )
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },

  {
    path: '/existing-cif-new-account/create-new-account/individualScreenForm',
    component: lazy(
      async () =>
        await import(
          '../modules/screening/individualJointMinorScreening/existingIndividualScreening'
        )
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },

  {
    path: '/existing-cif-new-account/create-new-account/individualScreenForm/:case_id',
    component: lazy(
      async () =>
        await import(
          '../modules/screening/individualJointMinorScreening/existingIndividualScreening'
        )
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },

  {
    path: '/existing-cif-new-account/create-new-account/corporateScreenForm',
    component: lazy(
      async () => await import('../modules/screening/corporateScreening/existingCorporateScreening')
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },

  {
    path: '/existing-cif-new-account/create-new-account/corporateScreenForm/:case_id',
    component: lazy(
      async () => await import('../modules/screening/corporateScreening/existingCorporateScreening')
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },

  {
    path: '/existing-cif-new-account/create-new-account/normal-individual-preliminary-form',
    component: lazy(
      async () =>
        await import(
          '../modules/existingCIFNewAccount/branchMakerChecker/Individual/normalIndividualForm'
        )
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },
  {
    path: '/existing-cif-new-account/create-new-account/normal-individual-preliminary-form/:case_id',
    component: lazy(
      async () =>
        await import(
          '../modules/existingCIFNewAccount/branchMakerChecker/Individual/normalIndividualForm'
        )
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },

  {
    path: '/existing-cif-new-account/create-new-account/corporate-form',
    component: lazy(
      async () =>
        await import(
          '../modules/existingCIFNewAccount/branchMakerChecker/corporate/normalCorporateForm'
        )
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },
  {
    path: '/existing-cif-new-account/create-new-account/corporate-form/:case_id',
    component: lazy(
      async () =>
        await import(
          '../modules/existingCIFNewAccount/branchMakerChecker/corporate/normalCorporateForm'
        )
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },

  {
    path: '/existing-cif-new-account/branch-checker-review-corporate',
    component: lazy(
      async () => await import('../modules/newCifNewAccount/branchChecker/corporate/index')
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },

  {
    path: '/existing-cif-new-account/branch-checker-review-individual',
    component: lazy(
      async () => await import('../modules/newCifNewAccount/branchChecker/Individual/index')
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },

  //ENquiry Module

  {
    path: '/cms/forms-and-download',
    component: FormDownloadComponent,
    exact: true,
  },

  //Recommender
  {
    path: '/recommender',
    component: lazy(async () => await import('../modules/common/Recommender/Recommender')),
    exact: true,
  },
  //account List
  {
    path: '/account-list',
    component: lazy(async () => await import('../modules/accountStatus/index')),
    exact: true,
  },
  //account maintainance

  {
    path: '/account-maintenance',
    component: lazy(async () => await import('../modules/accountMaintainance/index')),
    exact: true,
  },
 
  {
    path: '/account-maintenance/initiate',
    component: lazy(
      async () => await import('../modules/accountMaintainance/AccountMiantainanceForm')
    ),
    exact: true,
  },
  {
    path: '/account-maintenance/initiate/:case_id',
    component: lazy(
      async () => await import('../modules/accountMaintainance/AccountMiantainanceForm')
    ),
    exact: true,
  },
   {
    path: '/account-maintenance/review/:case_id',
    component: lazy(async () => await import('../modules/accountMaintainance/index')),
    exact: true,
  },

  {
    path: '/kyc-information-change/initiate/:case_id',
    component: lazy(async () => await import('../modules/kyc-update/KycForm')),
    exact: true,
  },
  {
    path: '/kyc-information-change/initiate',
    component: lazy(async () => await import('../modules/kyc-update/KycForm')),
    exact: true,
  },
  {
    path: '/kyc-information-change',
    component: lazy(async () => await import('../modules/kyc-update/index')),
    exact: true,
  },
  {
    path: '/kyc-information-change/initiate/review/:case_id',
    component: lazy(async () => await import('../modules/kyc-update/ReviewUpdateKyc')),
    exact: true,
  },
  {
    path: '/kyc-information-change/initiate/review',
    component: lazy(async () => await import('../modules/kyc-update/ReviewUpdateKyc')),
    exact: true,
  },

  //ocr route set up

  {
    path: '/ocr-acc-opening',
    component: lazy(async () => await import('../modules/ocrAccountOpening/index')),
    exact: true,
  },
  {
    path: '/ocr-acc-opening/initiate',
    component: lazy(async () => await import('../modules/ocrAccountOpening/OCRForm')),
    exact: true,
  },
  {
    path: '/ocr-acc-opening/initiate/:case_id',
    component: lazy(async () => await import('../modules/ocrAccountOpening/OCRForm')),
    exact: true,
  },
  // Master Data

  {
    path: '/master-data/country',
    component: lazy(async () => await import('../modules/masterData/country/pages/CountryTable')),
    exact: true,
  },
  {
    path: '/master-data/product-category',
    component: lazy(
      async () => await import('../modules/masterData/productCategory/pages/ProductCategoryTable')
    ),
    exact: true,
  },
  {
    path: '/master-data/segments',
    component: lazy(async () => await import('../modules/masterData/segmentes/page')),
    exact: true,
  },
  {
    path: '/master-data/sub-segments',
    component: lazy(async () => await import('../modules/masterData/sub-segments/page')),
    exact: true,
  },
  {
    path: '/master-data/currencies',
    component: lazy(async () => await import('../modules/masterData/currencies/page')),
    exact: true,
  },
  {
    path: '/master-data/cities',
    component: lazy(async () => await import('../modules/masterData/cities/page')),
    exact: true,
  },
  {
    path: '/master-data/document-types',
    component: lazy(async () => await import('../modules/masterData/document-types/page')),
    exact: true,
  },
  {
    path: '/master-data/legal-entities',
    component: lazy(async () => await import('../modules/masterData/legal-entities/page')),
    exact: true,
  },
  {
    path: '/master-data/nationalities',
    component: lazy(async () => await import('../modules/masterData/nationalities/page')),
    exact: true,
  },
  {
    path: '/master-data/sectors',
    component: lazy(async () => await import('../modules/masterData/sector/index')),
    exact: true,
  },
  {
    path: '/master-data/sub-sectors',
    component: lazy(async () => await import('../modules/masterData/subsector/index')),
    exact: true,
  },
  {
    path: '/master-data/provinces',
    component: lazy(async () => await import('../modules/masterData/provinces/index')),
    exact: true,
  },
  {
    path: '/master-data/occupation-types',
    component: lazy(async () => await import('../modules/masterData/occupationTypes/index')),
    exact: true,
  },
  {
    path: '/master-data/issusing-authority',
    component: lazy(async () => await import('../modules/masterData/issusingAuthority/index')),
    exact: true,
  },
  {
    path: '/master-data/source-of-income',
    component: lazy(async () => await import('../modules/masterData/sourceofIncome/index')),
    exact: true,
  },
  {
    path: '/master-data/entity-class',
    component: lazy(async () => await import('../modules/masterData/entityClass/index')),
    exact: true,
  },
  //jv corporate
  {
    path: '/new-cif-new-account/create-new-jv-account',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/branchMaker/components/jv-corporate/JVCorporateForm'
        )
    ),

    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-jv-account/:case_id',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/branchMaker/components/jv-corporate/JVCorporateForm'
        )
    ),

    exact: true,
  },

  {
    path: '/new-cif-new-account/create-new-jv-account/review/:case_id',
    component: lazy(
      async () =>
        await import('../modules/newCifNewAccount/branchMaker/components/jv-corporate/JVReviewForm')
    ),

    exact: true,
  },

  //tat report
  {
    path: '/tat-report',
    component: lazy(async () => await import('../modules/TatReport/index')),
    exact: true,
  },

  // corn job
   {
    path: '/corn-job-report',
    component: lazy(async () => await import('../modules/formGenerator/components/CornJobReport/index')),
    exact: true,
  },

  //online account Opeaning

  {
    path: '/initiate/online-account-opening/:case_id',
    component: lazy(
      async () => await import('../modules/onlineAccountOpening/AccountRequestViewPage')
    ),
    exact: true,
  },
  {
    path: '/online-account-opening',
    component: lazy(async () => await import('../modules/onlineAccountOpening')),
    exact: true,
  },

  {
    path: '/online-account-opening/review/:case_id',
    component: lazy(
      async () => await import('../modules/onlineAccountOpening/OnlineAccountOpeningReviewForm')
    ),
    exact: true,
  },

  //bulk account-opening
  {
    path: '/bulk-account-opening/master-batch-list',
    component: lazy(async () => await import('../modules/BulkAccount/MasterBatchList')),
    exact: true,
  },
  {
    path: '/bulk-account-opening/master-batch-list/view/:case_id',
    component: lazy(async () => await import('../modules/BulkAccount/AccountOpeningRequestPage')),
    exact: true,
  },
  {
    path: '/bulk-account-opening/child-batch-list',
    component: lazy(async () => await import('../modules/BulkAccount/ChildBatchList')),
    exact: true,
  },
  {
    path: '/bulk-account-opening/api-failure',
    component: lazy(async () => await import('../modules/BulkAccount/ApiFailureList')),
    exact: true,
  },
  {
    path: '/bulk-account-opening/api-success',
    component: lazy(async () => await import('../modules/BulkAccount/ApiSuccessList')),
    exact: true,
  },
  


  {
    path: '/bulk-account-opening/master-batch-list/:case_id',
    component: lazy(async () => await import('../modules/BulkAccount/MakerForm')),
    exact: true,
  },

   {
    path: '/bulk-account-opening/master-batch-list/review/:case_id',
    component: lazy(async () => await import('../modules/BulkAccount/index')),
    exact: true,
  },









  //documentupload
   {
    path: '/document-upload',
    component: lazy(async () => await import('../modules/formGenerator/components/documentupload')),
    exact: true,
  },
   {
    path: '/document-upload/initiate',
    component: lazy(async () => await import('../modules/formGenerator/components/documentupload/DocumentUploadForm')),
    exact: true,
  },

  {
    path: '/document-upload/initiate/:case_id',
    component: lazy(async () => await import('../modules/formGenerator/components/documentupload/DocumentUploadForm')),
    exact: true,
  },

   {
    path: '/document-upload/review/:case_id',
    component: lazy(async () => await import('../modules/formGenerator/components/documentupload/ReviewDocumentDeferral')),
    exact: true,
  },


]
